/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewItem_item = {
    readonly title: string | null;
    readonly linkData: {
        readonly path: string | null;
    };
    readonly quickViewDisplay: {
        readonly title: string | null;
        readonly mobileTitle: string | null;
        readonly paragraphs: ReadonlyArray<{
            readonly key: string | null;
            readonly text: string | null;
            readonly mobileText: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_item" | "QuickViewCreators_item">;
    readonly " $refType": "QuickViewItem_item";
};
export type QuickViewItem_item$data = QuickViewItem_item;
export type QuickViewItem_item$key = {
    readonly " $data"?: QuickViewItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewItem_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
];
return {
  "kind": "Fragment",
  "name": "QuickViewItem_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quickViewDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "mobileTitle",
          "name": "title",
          "args": (v1/*: any*/),
          "storageKey": "title(formatType:\"MOBILE\")"
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "paragraphs",
          "storageKey": null,
          "args": null,
          "concreteType": "QuickViewParagraph",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "key",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": "mobileText",
              "name": "text",
              "args": (v1/*: any*/),
              "storageKey": "text(formatType:\"MOBILE\")"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "QuickViewCategoryParagraph_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "QuickViewCreators_item",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'fe32b3cf6b313d40a108d24f42845ece';
export default node;
